<template>
  <AdminEmployeeDetailPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminEmployeeDetailPage from "shared-ui/pages/AdminEmployeeDetailPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_employees.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
